/// <reference path='discounts.module.ts' />
/// <reference path='../../../../typings/index.d.ts' />

module Meevo.Plugins.Discounts {
    import DiscountTypeEnum = Meevo.Model.DiscountTypeEnum;
    import DiscountEntityTypeEnum = Meevo.Model.DiscountEntityTypeEnum;
    import DiscountRedeemableLimitPerTypeEnum = Meevo.Model.DiscountRedeemableLimitPerTypeEnum;
    import DiscountBasedOnEnum = Meevo.Model.DiscountBasedOnEnum;

    export interface IDiscountsService {
        discountTypes: Model.EnumDto[];
        entityTypes: Model.EnumDto[];
        redeemableLimitTypes: Model.EnumDto[];
        baseOnTypes: Model.EnumDto[];
    }

    export class DiscountsService implements IDiscountsService {
        private _discountTypes: Model.EnumDto[] = [];
        private _entityTypes: Model.EnumDto[] = [];
        private _redeemableLimitTypes: Model.EnumDto[] = [];
        private _baseOnTypes: Model.EnumDto[] = [];

        constructor (
            protected dataService: Meevo.Components.BaseClasses.IDataService
        ) {

            DiscountsService.getEnums(dataService, this.discountTypes, this.entityTypes, this.redeemableLimitTypes, this.baseOnTypes);

        }


        static getEnums(dataService: Meevo.Components.BaseClasses.IDataService,
                        discountTypes: Model.EnumDto[],
                        entityTypes: Model.EnumDto[],
                        redeemableLimitTypes: Model.EnumDto[],
                        baseOnTypes: Model.EnumDto[]): void {
            dataService.getEnumList(Meevo.Model.EnumTypeEnum.DiscountTypeEnum,
                Meevo.Model.EnumTypeEnum.DiscountEntityTypeEnum,
                Meevo.Model.EnumTypeEnum.DiscountRedeemableLimitPerTypeEnum,
                Meevo.Model.EnumTypeEnum.BOGOBasedOnTypeEnum).then((enumsList) => {
                    let enumsDictionary = _(enumsList).groupBy((item: Model.EnumDto) => { return item.enumTypeId; });
                    discountTypes.push(...(enumsDictionary[Meevo.Model.EnumTypeEnum.DiscountTypeEnum] as Model.EnumDto[]));
                    entityTypes.push(...(enumsDictionary[Meevo.Model.EnumTypeEnum.DiscountEntityTypeEnum] as Model.EnumDto[]));
                    redeemableLimitTypes.push(...(enumsDictionary[Meevo.Model.EnumTypeEnum.DiscountRedeemableLimitPerTypeEnum] as Model.EnumDto[]));
                    baseOnTypes.push(...(enumsDictionary[Meevo.Model.EnumTypeEnum.BOGOBasedOnTypeEnum] as Model.EnumDto[]));
                });
        }

        get baseOnTypes(): Model.EnumDto[] {
            return this._baseOnTypes;
        }

        get discountTypes(): Model.EnumDto[] {
            return this._discountTypes;
        }

        get entityTypes(): Model.EnumDto[] {
            return this._entityTypes;
        }

        get redeemableLimitTypes(): Model.EnumDto[] {
            return this._redeemableLimitTypes;
        }


        static factory(): Function {
            let instance = (
                dataService: Meevo.Components.BaseClasses.IDataService
            ) => {
                return new DiscountsService(dataService);
            };

            instance.$inject = ['meevo.components.common.DataService'];
            return instance;
        }
    }

    angular.module('meevo.plugins.discounts')
        .service('meevo.plugins.discounts.discountsService', DiscountsService.factory());
}